<script setup>
import { ref, computed, watch } from 'vue'
import { useMapStore } from '@/stores/map'
import { useDataStore } from '@/stores/data'
import { useAppStore } from '@/stores/app'
import { getIconForLocation } from '@/utils/journeyUtils'
import cloneDeep from 'lodash/cloneDeep'
import geoService from '@/services/geoService'

const appStore = useAppStore()
const mapStore = useMapStore()
const dataStore = useDataStore()
const query = ref('')
const results = ref([])
const noResults = ref(false)
const isSearching = ref(false)

var selectedLocation = ref(null)
const hasChanged = ref(false)

const debounce = (fn, delay) => {
	let timeoutId
	return (...args) => {
		clearTimeout(timeoutId)
		timeoutId = setTimeout(() => fn(...args), delay)
	}
}

const debouncedSearch = debounce(async () => {
	if (query.value.length < 3) return
	noResults.value = false
	isSearching.value = true

	let location = dataStore.currentEditTrip[dataStore.currentLocationType]

	console.warn('GeoCoder: debouncedSearch', query.value, dataStore.currentEditTrip, dataStore.currentEditTrip[dataStore.currentLocationType], location)

	results.value = await geoService.search(query.value, location)
	isSearching.value = false
	//results.value = await mapStore.mapboxSearch(query.value)
	if (results.value.length === 0) {
		noResults.value = true
	}
}, 1000)

const setMapStoreCurrentEditTrip = (place) => {
	console.warn('GeoCoder: setMapStoreCurrentEditTrip', place)
	if (mapStore.currentEditTrip && mapStore.currentEditTrip[dataStore.currentLocationType]) {
		mapStore.setCurrentEditTripLocationForPlace(place, dataStore.currentLocationType)
	} else {
		console.warn('GeoCoder: setMapStoreCurrentEditTrip', 'No currentEditTrip')
	}
}

const selectLocation = async (selectedPlace) => {
	console.warn('selectLocation', selectedPlace)

	//const resultNew = await mapStore.getPlaceDetails(suggestion.id)
	const placeWithDetails = await geoService.getPlaceDetails(selectedPlace)
	console.warn('placeWithDetails', placeWithDetails)

	if (placeWithDetails?.latitude) {
		setMapStoreCurrentEditTrip(placeWithDetails)
		selectedLocation.value = placeWithDetails
		mapStore.flyToLocation(placeWithDetails, 16, 1000)
		query.value = placeWithDetails.title
		results.value = []
		hasChanged.value = true
	}
}

const cancelClick = () => {
	query.value = ''
	selectedLocation.value = null
	mapStore.currentEditTrip = null
	mapStore.clearNewTripMarkes()
	dataStore.showGeocoder = false

	// var currentTrips = JSON.parse(JSON.stringify(dataStore.currentJourney.trips))
	// currentTrips[dataStore.currentTripIndex] = dataStore.currentEditTrip
	// mapStore.plotTripsInner(currentTrips, dataStore.currentTripIndex)

	mapStore.plotCurrentEdit()

	if (appStore.currentPage == 'edit') {
		appStore.bottomSheet.setHeightNormal(300, 'Geocoder: cancelClick')
	} else {
		appStore.bottomSheet.autoResize(300, true, true, 'Geocoder: cancelClick')
	}
}

const setLocation = () => {
	query.value = ''
	if (dataStore.currentEditTrip) dataStore.currentEditTrip = cloneDeep(mapStore.currentEditTrip)

	// Try to match POI place to Google Place ID
	if (dataStore.currentEditTrip?.destination?.place_id?.startsWith('poi_')) {
		geoService.getGooglePlaceId(dataStore.currentEditTrip.destination).then((placeWithGooglePlaceId) => {
			console.warn('setLocation: placeWithGooglePlaceId', placeWithGooglePlaceId)
			if (placeWithGooglePlaceId && placeWithGooglePlaceId.google_place_id) {
				dataStore.currentEditTrip.destination.place_id = placeWithGooglePlaceId.place_id
				dataStore.currentEditTrip.destination.google_place_id = true
			}
		})
	}

	mapStore.currentEditTrip = null
	dataStore.showGeocoder = false
	mapStore.plotCurrentEdit()
	setTimeout(() => {
		appStore.bottomSheet.autoResize(300)
		selectedLocation.value = null
	}, 300)
}

const queryBlured = () => {
	noResults.value = false
}

const queryClicked = () => {
	console.warn('GeoCoder: queryClicked', 'query', query.value, 'location', selectedLocation.value)
	if (query.value.length > 0) {
		results.value = []
		if (selectedLocation.value?.type === 'gps') query.value = ''
		selectedLocation.value = null
	}
}

const blurInput = () => {
	document.activeElement.blur()
	// const inputs = document.querySelectorAll('input, textarea, select');
	// inputs.forEach(input => {
	// 	input.blur();
	// });
}

const init = () => {
	var editTrip = null
	if (dataStore.currentEditTrip && dataStore.currentEditTrip.origin && dataStore.currentEditTrip.destination) {
		editTrip = cloneDeep(dataStore.currentEditTrip)
	}
	mapStore.currentEditTrip = editTrip
	console.warn('GeoCoder: showGeocoder', editTrip)
	query.value = ''
	results.value = []
	selectedLocation.value = null
	hasChanged.value = false
	mapStore.setCoordinateChangeListener(async (lngLat) => {
		let place = null
		const location = { latitude: lngLat.lat, longitude: lngLat.lng }
		//const place = await geoService.getPlaceOrAddressForLocation(location)

		var adjustedTrip = cloneDeep(mapStore.currentEditTrip)
		if (adjustedTrip && dataStore.currentLocationType) {
			adjustedTrip[dataStore.currentLocationType].latitude = lngLat.lat
			adjustedTrip[dataStore.currentLocationType].longitude = lngLat.lng
			mapStore.currentEditTrip = adjustedTrip

			// Get nearest place or address from POI database
			place = await geoService.getNearestPlaceOrAddressFromPoiForLocation(location)

			console.warn('GeoCoder: adjustedTrip', place)
		} else {
			console.warn('GeoCoder: CoordinateChangeListener', 'No currentEditTrip to update')
		}

		if (place) {
			query.value = place.title
			selectedLocation.value = place
			setMapStoreCurrentEditTrip(place)
			blurInput()
		}
		// var placeTitles = await geoService.getPlaceForLocation(location)

		// var pois = await geoService.getPoiForLocation(location)
		// console.warn('GeoCoder: getPoiForLocation', lngLat, placeTitles, pois)

		// const place = {
		// 	title: placeTitles.title,
		// 	subTitle: placeTitles.subTitle,
		// 	latitude: lngLat.lat.toFixed(5),
		// 	longitude: lngLat.lng.toFixed(5),
		// 	type: 'gps',
		// }
	})
}

watch(
	() => dataStore.showGeocoder,
	(showGeocoder) => {
		if (showGeocoder) {
			init()
		}
	},
)

watch(
	() => query.value,
	() => (noResults.value = false),
)

watch(
	() => mapStore.currentEditTrip,
	() => {
		if (dataStore.showGeocoder) {
			hasChanged.value = true
		}
	},
	{ deep: true },
)

const locationTypeTitle = computed(() => {
	if (dataStore.currentEditTrip?.stationary) return 'sted'
	return dataStore.currentLocationType === 'origin' ? 'avreisested' : 'reisemål'
})
</script>

<template>
	<div class="geocoder-container" @click="dataStore.showGeocoder = false" :class="{ visible: dataStore.showGeocoder }">
		<div class="geocoder" @click.stop>
			<div class="search-input" :class="{ selected: selectedLocation, searching: isSearching }">
				<input v-model="query" @input="debouncedSearch" type="text" placeholder="Søk etter sted eller adresse..." @click="queryClicked()" @blur="queryBlured()" />
				<div v-if="selectedLocation" class="subtitle">{{ selectedLocation.subTitle }}</div>
				<div v-if="selectedLocation?.type == 'gps'" class="tag" :class="selectedLocation?.type">
					{{ mapStore.formatLat(selectedLocation.latitude) }}<br />
					{{ mapStore.formatLng(selectedLocation.longitude) }}
				</div>
				<div v-if="selectedLocation?.type == 'subway'" class="tag" :class="selectedLocation?.type">T-bane</div>
				<div v-if="selectedLocation?.type == 'train'" class="tag" :class="selectedLocation?.type">Togstasjon</div>
				<LoadingSpinner class="loader" v-if="isSearching" />
			</div>
			<div v-if="results.length > 0 || noResults" class="results">
				<div v-for="result in results" :key="result.id" class="result-item" @click="selectLocation(result)">
					<div class="flex items-center gap-3 relative">
						<i :class="['fas', getIconForLocation(result)]"></i>
						<div class="titles">
							<div>{{ result.title }}</div>
							<div class="text-sm text-gray-500">{{ result.subTitle }}</div>
						</div>
						<div v-if="result?.type == 'subway'" class="tag" :class="result?.type">T-bane</div>
						<div v-if="result?.type == 'train'" class="tag" :class="result?.type">Togstasjon</div>
					</div>
				</div>
				<div v-if="noResults" class="empty-result">
					<em>Fant ingen treff på steder eller adresser</em>
				</div>
			</div>
		</div>
		<footer @click.stop>
			<div class="w-full">
				<div class="mb-4" style="line-height: 1.25rem">
					{{ mapStore.currentEditTripIsNew && dataStore.currentEditTrip && !dataStore.currentEditTrip[dataStore.currentLocationType]?.latitude ? 'Velg' : 'Endre' }}
					<strong>{{ locationTypeTitle }}</strong> ved å <strong>søke</strong> etter sted eller ved å <strong>trykke og holde</strong> på et punkt i kartet.
					<template v-if="selectedLocation || (dataStore.currentEditTrip && dataStore.currentEditTrip[dataStore.currentLocationType] && dataStore.currentEditTrip[dataStore.currentLocationType]?.latitude)">Du kan også <strong>dra</strong> i markøren for å flytte den. </template>
				</div>
				<div class="flex gap-6">
					<div class="button" @click="cancelClick()">Avbryt</div>
					<div @click="setLocation()" class="button full orange" :class="{ disabled: !hasChanged || !selectedLocation }">
						<i class="fas fa-floppy-disk"></i>
						<span>Lagre {{ locationTypeTitle }}</span>
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>

<style scoped>
.geocoder-container {
	position: absolute;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: start;
	background-color: rgba(0, 0, 0, 0);
	/* z-index: 1000; */
	pointer-events: none;
}

footer {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 1.5rem;
	background: white;
	box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
	transition: all 0.5s ease-out;
	transform: translateY(300px);
	opacity: 0;
	pointer-events: all;
}

.visible footer {
	transform: translateY(0);
	opacity: 1;
	pointer-events: all;
	padding-bottom: max(env(safe-area-inset-bottom), 1.5rem);
}

.geocoder {
	margin: 1.5rem;
	margin-top: max(env(safe-area-inset-top), 1.5rem);
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	transition: all 0.5s ease-out;
	transform: translateY(-100px);
	pointer-events: none;
	opacity: 0;
}

.visible .geocoder {
	transform: translateY(0);
	opacity: 1;
	pointer-events: all;
}

.search-input {
	width: 100%;
	padding: 0.75rem;
	padding-right: 2rem;
	border-radius: 1.5rem;
	padding-left: 1rem;
	border-width: 0px;
	box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
	background: white;
	position: relative;
}

.search-input .loader {
	position: absolute;
	right: 0px;
	top: 0px;
	bottom: 0px;
	margin: auto;
	margin-right: 1rem;
}

.search-input .gps {
	right: 1rem;
}

.search-input input,
.search-input input:focus {
	width: 100%;
	padding: 0px;
	border: none;
	outline: none;
	box-shadow: none;
}

.selected input {
	font-weight: 400;
}

.selected .subtitle {
	font-weight: 300;
	font-size: 0.9rem;
	line-height: 1rem;
}

.results {
	margin-top: -2rem;
	background: #fcfcfc;
	border-radius: 1rem;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
	max-height: 80vh;
	overflow-y: auto;
}

.result-item,
.empty-result {
	padding: 0.5rem;
	padding-left: 1rem;
	cursor: pointer;
	border-bottom: 1px solid #eee;
	padding-bottom: 0.75rem;
}

.empty-result {
	padding-top: 2.75rem;
	border-bottom: none;
	display: flex;
}

.result-item:first-child {
	padding-top: 3rem;
}

.result-item:last-child {
	border-bottom: none;
}

.result-item .titles {
	line-height: 1.15rem;
}

.result-item .tag {
	right: 0.5rem;
}

.result-item:hover {
	background: #f5f5f5;
}
</style>
